module.exports = __webpack_public_path__ + "static/media/top.f4627585.svg";